<template>
  <h1 class="title">About Page</h1>
</template>